export const RightAlignedButtons = ({ children }) => {

    return (
        <div className="d-flex">
            <div className="mt-10px ms-auto">
                {children}
            </div>
        </div>
    );
};

export const LeftAlignedButtons = ({ children }) => {

    return (
        <div className="d-flex">
            <div className="mt-10px">
                {children}
            </div>
        </div>
    );
};